import { render, staticRenderFns } from "./Combobox.vue?vue&type=template&id=49907ae4&scoped=true&"
import script from "./Combobox.vue?vue&type=script&lang=ts&"
export * from "./Combobox.vue?vue&type=script&lang=ts&"
import style0 from "./Combobox.vue?vue&type=style&index=0&id=49907ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49907ae4",
  null
  
)

export default component.exports